/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useTableData } from "../data/useTableData";
import { useAgGridTransformer } from "../transformers/useAgGridTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import { ComponentContextReadyState } from "@sa/rep-core";
import { Table } from "../../../components/Table";
import { debounceTime } from "rxjs/operators";
import { useExportSource } from "../hooks/useExportSource";
import { usePricesDateLabel } from "../hooks/usePricesDateLabel";
import "./custom-table.css";
import { useSubscriptionSource } from "../../../shared";

export const ComponentTables: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResultTable = useHookSubscribe(null, context.olapResultTable$);
  const source = useHookSubscribe(null, context.sources$);
  const loading = useHookSubscribe(null, context.loading$);
  useExportSource(source);
  useSubscriptionSource(source);

  const tableData = useTableData(olapResultTable);
  const agGridData = useAgGridTransformer(tableData);
  const pricesDateLabel = usePricesDateLabel(tableData);

  if (window["exportMode"]) {
    window["exportReady"] = !loading;
  }
  if (loading) {
    return <ComponentPreloader />;
  }

  return (
    <>
      <ComponentSourcetitle>&nbsp;</ComponentSourcetitle>
      <ComponentTitle>Prices as of {pricesDateLabel}</ComponentTitle>
      <div className="custom-tables-slide21-box">
        {agGridData ? <Table className="custom-table-slide21" {...agGridData} /> : <ComponentPreloader />}
      </div>
    </>
  );
};
